import { render } from "./UploadFormItem.vue?vue&type=template&id=3f69ad72"
import script from "./UploadFormItem.vue?vue&type=script&lang=ts"
export * from "./UploadFormItem.vue?vue&type=script&lang=ts"
script.render = render

export default script